/* global axios */
import ApiClient from '../ApiClient';

class InternalRooms extends ApiClient {
  constructor() {
    super('internal/rooms', { accountScoped: true });
  }

  createDirect(userId) {
    return axios.post(`${this.url}/direct`, { user_id: userId });
  }

  createGroup({ name, userIds, visibility = 'restricted' }) {
    return axios.post(this.url, {
      name,
      user_ids: userIds,
      visibility,
    });
  }

  update(roomId, data) {
    const config =
      data instanceof FormData
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : {};
    return axios.patch(`${this.url}/${roomId}`, data, config);
  }

  deleteAvatar(roomId) {
    return axios.delete(`${this.url}/${roomId}/avatar`);
  }

  markRead(roomId) {
    return axios.post(`${this.url}/${roomId}/mark_read`);
  }
}

export default new InternalRooms();
